import getFaviconPath from './getFaviconPath';

export default function fixFaviconPath(exp: string) {
  const links = document.querySelectorAll("link[rel$='icon']");
  if (links.length > 0) {
    const path = getFaviconPath(exp);
    links.forEach((elem) => { elem.setAttribute('href', path); });
  }
}
